import { Button, Card, Col, Container, Row } from 'react-bootstrap';
import { motion } from 'motion/react';
import marketData from '../../data/marketData.json';

const CTA = () => {
  const { cta } = marketData

  const cardVariants = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: "easeOut" }
    }
  }

  return (
    <section id="contact-market" className="section-lg overflow-hidden">
      <Container>
        <motion.div
          variants={cardVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          whileHover={{ scale: 1.01, transition: { duration: 0.3 } }}
        >
          <Card className="border-0 shadow rounded-4 bg-white">
            <Card.Body className="p-4 p-lg-5">
              <Row className="align-items-center g-4">
                <Col lg={8} xs={12}>
                  <motion.h2 className="text-primary mb-2"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.2, duration: 0.5 }}
                  >
                    {cta.title}
                  </motion.h2>
                  <motion.p className="text-secondary mb-3"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.3, duration: 0.5 }}
                  >
                    {cta.description}
                  </motion.p>
                  <motion.div className="d-flex flex-wrap gap-2"
                    initial={{ opacity: 0, y: 20 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.4, duration: 0.5 }}
                  >
                    <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                      <Button href="/index.html#contactus" className="btn-gradient">Talk to an Expert</Button>
                    </motion.div>
                    <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                      <Button href="/index.html#pricing" variant="outline-primary">See Plans</Button>
                    </motion.div>
                  </motion.div>
                </Col>
                <Col lg={4} xs={12} className="text-lg-end text-start">
                  <motion.div className="p-3 bg-light rounded-3"
                    initial={{ opacity: 0, scale: 0.9 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true }}
                    transition={{ delay: 0.5, duration: 0.5 }}
                    whileHover={{ scale: 1.05 }}
                  >
                    <small className="text-secondary d-block">{cta.statLabel}</small>
                    <h5 className="mb-0">{cta.statValue}</h5>
                  </motion.div>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </motion.div>
      </Container>
    </section>
  )
}

export default CTA;